import type { IFuseOptions } from "fuse.js";
import Fuse from "fuse.js";
import { computed, shallowRef, watch, type Ref } from "vue";

export function useSmartSearch<T extends Record<string, any>>(
  search: Ref<string>,
  list: Ref<T[]>,
  fields: (keyof T)[]
) {
  // Use shallowRef so Vue can track when the Fuse instance changes
  const fuseRef = shallowRef<Fuse<T> | null>(null);

  const fuseOptions: IFuseOptions<T> = {
    keys: fields.map((key) => key as string),
    includeScore: true,
    threshold: 0.35,
    ignoreLocation: true,
  };

  const rebuildIndex = () => {
    fuseRef.value = new Fuse(list.value, fuseOptions);
  };

  watch(list, rebuildIndex, { immediate: true });

  const filtered = computed(() => {
    const q = search.value;
    const fuse = fuseRef.value; // Track fuseRef as dependency
    if (!q || !fuse) return list.value;
    return fuse.search(q).map((r) => r.item);
  });

  return { filtered };
}
